import {Component, Input, OnInit, QueryList, ViewChildren, ViewEncapsulation} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import * as _ from 'lodash';

@Component({
  selector: 'offline-node-summary',
  templateUrl: './offline-node-summary.component.html',
  styleUrls: ['./offline-node-summary.component.less'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('openCloseNodeStates', [
      state('true', style({
        height: '*'
      })),
      state('false', style({
        height: '0px',
        visibility: 'hidden'
      })),
      transition('false <=> true', [
        animate('0.3s')
      ])
    ])
  ]
})
export class OfflineNodeSummaryComponent implements OnInit {

  @Input()
  set selection(selection: any) {
    this.dataInitialization(selection);
  }

  constructor() {}

  isCollapsed = true;
  node: any;

  ngOnInit(): void {
  }

  nodeOperativeStateToColor(status): any {
    switch (status) {
      case 0:
        return {c2n: 'red', n2c: 'red', n2rR: 'red', n2rN: 'red'};
      case 1:
        return {c2n: 'red', n2c: 'red', n2rR: 'red', n2rN: 'green'};
      case 2:
        return {c2n: 'red', n2c: 'red', n2rR: 'green', n2rN: 'red'};
      case 3:
        return {c2n: 'red', n2c: 'red', n2rR: 'green', n2rN: 'green'};
      case 4:
        return {c2n: 'red', n2c: 'green', n2rR: 'red', n2rN: 'red'};
      case 5:
        return {c2n: 'red', n2c: 'green', n2rR: 'red', n2rN: 'green'};
      case 6:
        return {c2n: 'red', n2c: 'green', n2rR: 'green', n2rN: 'red'};
      case 7:
        return {c2n: 'red', n2c: 'green', n2rR: 'green', n2rN: 'green'};
      case 8:
        return {c2n: 'green', n2c: 'red', n2rR: 'red', n2rN: 'red'};
      case 9:
        return {c2n: 'green', n2c: 'red', n2rR: 'red', n2rN: 'green'};
      case 10:
        return {c2n: 'green', n2c: 'red', n2rR: 'green', n2rN: 'red'};
      case 11:
        return {c2n: 'green', n2c: 'red', n2rR: 'green', n2rN: 'green'};
      case 12:
        return {c2n: 'green', n2c: 'green', n2rR: 'red', n2rN: 'red'};
      case 13:
        return {c2n: 'green', n2c: 'green', n2rR: 'red', n2rN: 'green'};
      case 14:
        return {c2n: 'green', n2c: 'green', n2rR: 'green', n2rN: 'red'};
      case 15:
        return {c2n: 'green', n2c: 'green', n2rR: 'green', n2rN: 'green'};

      case 94:
        return {c2n: 'red', n2c: 'red', n2rR: 'red', n2rN: 'red'};
      default:
        return {c2n: 'grey', n2c: 'grey', n2rR: 'grey', n2rN: 'grey'};
    }
  }

  initializeData(): void {
    this.node.topologyGroupsInfo = _.isEmpty(this.node.topologyGroups) ? '' :
      this.node.topologyGroups.map(group => group.name).join(', ');
  }

  private dataInitialization(selection: any): void {
    if (_.isNil(selection)) { return; }

    const shapes = selection.nodes;
    const connections = selection.edges;
    if (shapes.length === 1 && connections.length === 0 && shapes[0].shapeType === 'node') {
      this.node = shapes[0].dataItem;
      this.initializeData();
    }
  }
}
